export const departurePortsDe = [
  {
    text: "Aberdeen (Schottland)",
    value: "12460",
  },
  {
    text: "Abu Dhabi (VAE)",
    value: "12462",
  },
  {
    text: "Adelaide (South Australia, Australien)",
    value: "12466",
  },
  {
    text: "Amsterdam (Niederlande)",
    value: "12509",
  },
  {
    text: "Anchorage (Alaska, USA)",
    value: "12511",
  },
  {
    text: "Ancona (Italien)",
    value: "12512",
  },
  {
    text: "Antalya (Türkei)",
    value: "12519",
  },
  {
    text: "Antwerpen (Flandern, Belgien)",
    value: "12527",
  },
  {
    text: "Aqaba (Jordanien)",
    value: "12530",
  },
  {
    text: "Aschaffenburg (Deutschland)",
    value: "12543",
  },
  {
    text: "Athen (Grienchenland)",
    value: "12549",
  },
  {
    text: "Auckland (Neuseeland)",
    value: "12553",
  },
  {
    text: "Balboa / Panama ",
    value: "12568",
  },
  {
    text: "Baltimore (Maryland, USA)",
    value: "12572",
  },
  {
    text: "Baltra (Galapagos-Inseln)",
    value: "12573",
  },
  {
    text: "Bamberg (Deutschland)",
    value: "12574",
  },
  {
    text: "Bangkok (Thailand)",
    value: "12578",
  },
  {
    text: "Barcelona (Spanien)",
    value: "12585",
  },
  {
    text: "Bari (Italien)",
    value: "12587",
  },
  {
    text: "Basel (Schweiz)",
    value: "12591",
  },
  {
    text: "Belém (Para, Brasilien)",
    value: "12605",
  },
  {
    text: "Belfast (Nordirland)",
    value: "12606",
  },
  {
    text: "Benoa (Bali, Indonesien)",
    value: "12610",
  },
  {
    text: "Bergen (Norwegen)",
    value: "12614",
  },
  {
    text: "Berlin (Deutschland)",
    value: "12617",
  },
  {
    text: "Bilbao (Baskenland, Spanien)",
    value: "12624",
  },
  {
    text: "Bordeaux (Frankreich)",
    value: "12646",
  },
  {
    text: "Boston (Massachusetts, USA)",
    value: "12650",
  },
  {
    text: "Bremerhaven (Deutschland)",
    value: "12662",
  },
  {
    text: "Bridgetown (Barbados)",
    value: "12666",
  },
  {
    text: "Brindisi (Italien)",
    value: "12667",
  },
  {
    text: "Brisbane (Queensland, Australien)",
    value: "12668",
  },
  {
    text: "Broome (Western Australia, Australien)",
    value: "12671",
  },
  {
    text: "Brugge (Flandern, Belgien)",
    value: "12673",
  },
  {
    text: "Brussel / Bruxelles (Brüssel, Belgien)",
    value: "12676",
  },
  {
    text: "Budapest (Ungarn)",
    value: "12678",
  },
  {
    text: "Buenos Aires (Argentinien)",
    value: "12680",
  },
  {
    text: "Caglliari (Sardinien, Italien)",
    value: "12695",
  },
  {
    text: "Cairns (Queensland, Australien)",
    value: "12697",
  },
  {
    text: "Callao / Lima (Peru)",
    value: "12700",
  },
  {
    text: "Cannes (Frankreich)",
    value: "12705",
  },
  {
    text: "Cape Liberty / New York (New Jersey, USA)",
    value: "12709",
  },
  {
    text: "Cartagena (Kolumbien)",
    value: "12715",
  },
  {
    text: "Casablanca (Marokko)",
    value: "12717",
  },
  {
    text: "Castries (St.Lucia)",
    value: "12721",
  },
  {
    text: "Charleston (South Carolina, USA)",
    value: "12738",
  },
  {
    text: "Chicago (illinois, USA)",
    value: "12749",
  },
  {
    text: "Christchurch (Neuseeland)",
    value: "12759",
  },
  {
    text: "Civitavecchia / Rom (Italien)",
    value: "12764",
  },
  {
    text: "Colombo (Sri Lanka)",
    value: "12777",
  },
  {
    text: "Colόn (Panama)",
    value: "12778",
  },
  {
    text: "Cozumel (Quintana Roo, Mexico)",
    value: "12793",
  },
  {
    text: "Dakar (Senegal)",
    value: "12801",
  },
  {
    text: "Darwin (Northern Territory, Australien)",
    value: "12808",
  },
  {
    text: "Doha (Katar)",
    value: "12831",
  },
  {
    text: "Dover (England)",
    value: "12839",
  },
  {
    text: "Dubai (VAE)",
    value: "12844",
  },
  {
    text: "Dublin (Irland)",
    value: "12845",
  },
  {
    text: "Dubrovnik (Kroatien)",
    value: "12846",
  },
  {
    text: "Dunedin / Port Chalmers (Neuseeland)",
    value: "12849",
  },
  {
    text: "Durban (Südafrika)",
    value: "12851",
  },
  {
    text: "Düsseldorf (Deutschland) ",
    value: "12855",
  },
  {
    text: "Edinburgh (Schottland)",
    value: "12865",
  },
  {
    text: "Engelhartszell / Passau (Deutschland)",
    value: "12878",
  },
  {
    text: "Fort Lauderdale (Florida, USA)",
    value: "12924",
  },
  {
    text: "Fort-de-France (Martinique)",
    value: "12926",
  },
  {
    text: "Frankfurt am Main (Deutschland)",
    value: "12930",
  },
  {
    text: "Fremantle / Perth (Western Australia, Australien)",
    value: "12937",
  },
  {
    text: "Funchai (Madeira, Portugal)",
    value: "12941",
  },
  {
    text: "Galveston (Texas, USA)",
    value: "12946",
  },
  {
    text: "Genua (Italien)",
    value: "12960",
  },
  {
    text: "Glasgow (Schottland)",
    value: "12977",
  },
  {
    text: "Greenock / Glasgow (Schottland)",
    value: "13002",
  },
  {
    text: "Greenwich / London (England)",
    value: "13003",
  },
  {
    text: "Guayaquil (Ecuador)",
    value: "13015",
  },
  {
    text: "Haifa (Israel)",
    value: "13024",
  },
  {
    text: "Haiphong (Vietnam)",
    value: "13027",
  },
  {
    text: "Hamburg (Deutschland)",
    value: "13036",
  },
  {
    text: "Hanga Roa (Osterinsel, Chile)",
    value: "13041",
  },
  {
    text: "Helsinki (Finnland)",
    value: "13067",
  },
  {
    text: "Hobart (Tasmanien, Australien)",
    value: "13080",
  },
  {
    text: "Ho-Chi-Minh-Stadt (Vietnam)",
    value: "13081",
  },
  {
    text: "Honfleur (Frankreich)",
    value: "13086",
  },
  {
    text: "Hongkong (China)",
    value: "13087",
  },
  {
    text: "Honiara (Guadalcanal, Salomonen)",
    value: "13088",
  },
  {
    text: "Honolulu ( Oahu, Hawaii, USA)",
    value: "13090",
  },
  {
    text: "IJmuiden / Amsterdam (Niederlande)",
    value: "13113",
  },
  {
    text: "Iquitos (Peru)",
    value: "13133",
  },
  {
    text: "Iraklio (Kreta, Griechenland)",
    value: "13134",
  },
  {
    text: "Istanbul (Türkei)",
    value: "13155",
  },
  {
    text: "Itajaí  (Santa Catarina, Brasilien)",
    value: "13156",
  },
  {
    text: "Jacksonville (Florida, USA)",
    value: "13164",
  },
  {
    text: "Juneau (Alaska, USA)",
    value: "13176",
  },
  {
    text: "Kanazawa (Honshū , Japan)",
    value: "13192",
  },
  {
    text: "Kangerlussuaq / Søndre Strømfjord (Grönland)",
    value: "13194",
  },
  {
    text: "Kabstadt (Südafrika)",
    value: "13202",
  },
  {
    text: "Karlsruhe (Deutschland)",
    value: "13206",
  },
  {
    text: "Keelung / Taipeh (Taiwan)",
    value: "13218",
  },
  {
    text: "Kelang / Kuala Lumpur (Malaysia)",
    value: "13222",
  },
  {
    text: "Kiel (Deutschland)",
    value: "13234",
  },
  {
    text: "Ko Samui (Thailand)",
    value: "13258",
  },
  {
    text: "Kobe (Honshū , Japan)",
    value: "13261",
  },
  {
    text: "Koblenz (Deutschland)",
    value: "13262",
  },
  {
    text: "Kochi / Cochin (Kerala, Indien)",
    value: "13264",
  },
  {
    text: "Köln ( Deutschland)",
    value: "13267",
  },
  {
    text: "Kopenhagen (Dänemark)",
    value: "13277",
  },
  {
    text: "Korfu (Griechenland)",
    value: "13280",
  },
  {
    text: "Kota Kinabalu (Malaysia)",
    value: "13287",
  },
  {
    text: "Kusadasi / Ephesus (Türkei)",
    value: "13306",
  },
  {
    text: "La Romana (Dominikanische Republik)",
    value: "13321",
  },
  {
    text: "La Spezia (Italien)",
    value: "13323",
  },
  {
    text: "Laem Chabang / Bangkok (Thailand)",
    value: "13328",
  },
  {
    text: "Larnaca (Zypern)",
    value: "13335",
  },
  {
    text: "Las Palmas (Gran Canaria , Kanaren)",
    value: "13337",
  },
  {
    text: "Lautoka (Viti Levu, Fidschi)",
    value: "13341",
  },
  {
    text: "Le Havre (Frankreich)",
    value: "13343",
  },
  {
    text: "Leith / Edinburgh (Schottland)",
    value: "13354",
  },
  {
    text: "Leixões / Porto (Portugal)",
    value: "13355",
  },
  {
    text: "Lima (Peru)",
    value: "13372",
  },
  {
    text: "Limassol (Zypern)",
    value: "13373",
  },
  {
    text: "Linz (Österreich)",
    value: "13377",
  },
  {
    text: "Lissabon (Portugal)",
    value: "13380",
  },
  {
    text: "Livorno / Florenz / Pisa (Italien)",
    value: "13386",
  },
  {
    text: "London (England)",
    value: "13393",
  },
  {
    text: "Long Beach (Kalifornien, USA)",
    value: "13395",
  },
  {
    text: "Longyearbyen (Spitzbergen, Svalbard)",
    value: "13396",
  },
  {
    text: "Los Angeles (Kalifornien, USA)",
    value: "13399",
  },
  {
    text: "Lyon (Frankreich)",
    value: "13414",
  },
  {
    text: "Lyttelton / Christchurch (Neuseeland)",
    value: "13416",
  },
  {
    text: "Mahe (Seychellen)",
    value: "13431",
  },
  {
    text: "Mainz (Deutschland)",
    value: "13433",
  },
  {
    text: "Maizuru (Honshū , Japan)",
    value: "13434",
  },
  {
    text: "Málaga (Spanien)",
    value: "13438",
  },
  {
    text: "Male (Malediven)",
    value: "13443",
  },
  {
    text: "Manaus (Amazonas, Brasilien)",
    value: "13450",
  },
  {
    text: "Manila (Philippinen)",
    value: "13457",
  },
  {
    text: "Marigot (Saint-Martin)",
    value: "13468",
  },
  {
    text: "Marseille (Frankreich)",
    value: "13473",
  },
  {
    text: "Maskat / Muscat (Oman)",
    value: "13478",
  },
  {
    text: "Melbourne (Victoria, Australien)",
    value: "13494",
  },
  {
    text: "Memphis (Tennessee, USA)",
    value: "13497",
  },
  {
    text: "Messina (Sizilien, Italien)",
    value: "13502",
  },
  {
    text: "Miami (Florida, USA)",
    value: "13504",
  },
  {
    text: "Milwaukee (Wiscousin, USA)",
    value: "13513",
  },
  {
    text: "Mobile (Alabama, USA)",
    value: "13524",
  },
  {
    text: "Mombasa (Kenia)",
    value: "13527",
  },
  {
    text: "Monte Carlo (Monaco)",
    value: "13532",
  },
  {
    text: "Montego Bay (Jamaika)",
    value: "13533",
  },
  {
    text: "Montevideo (Uruguay)",
    value: "13535",
  },
  {
    text: "Montreal (Québec, Kanada)",
    value: "13537",
  },
  {
    text: "Mumbai / Bombay (Maharashtra, Indien)",
    value: "13547",
  },
  {
    text: "Nantes (Frankreich)",
    value: "13567",
  },
  {
    text: "Nassau (New Providence, Bahamas)",
    value: "13571",
  },
  {
    text: "Neapel (Italien)",
    value: "13577",
  },
  {
    text: "New Orleans (Louisiana, USA)",
    value: "13584",
  },
  {
    text: "New York (New York, USA)",
    value: "13585",
  },
  {
    text: "Nizza (Frankreich)",
    value: "13600",
  },
  {
    text: "Nome (Alaska, USA)",
    value: "13601",
  },
  {
    text: "Norfolk (Virginia, USA)",
    value: "13604",
  },
  {
    text: "Nosy Be (Madagaskar)",
    value: "13608",
  },
  {
    text: "Nürnberg (Deutschland)",
    value: "13620",
  },
  {
    text: "Osaka (Honshū , Japan)",
    value: "13652",
  },
  {
    text: "Oslo (Norwegen)",
    value: "13654",
  },
  {
    text: "Otaru / Sapporo (Hokkaidō, Japan)",
    value: "13656",
  },
  {
    text: "Palermo (Sizilien, Italien)",
    value: "13664",
  },
  {
    text: "Palma (Mallorca, Balearische Inseln)",
    value: "13665",
  },
  {
    text: "Palmeira (Sal, Kap Verde)",
    value: "13666",
  },
  {
    text: "Papeete (Tahiti , Franz-Polynesien)",
    value: "13671",
  },
  {
    text: "Paris (Frankreich)",
    value: "13684",
  },
  {
    text: "Passau (Deutschland)",
    value: "13687",
  },
  {
    text: "Petropawlowsk-Kamtschatski (Kamtschatka, Russland)",
    value: "13701",
  },
  {
    text: "Philipsburg (St.Maarten)",
    value: "13704",
  },
  {
    text: "Phuket (Thailand)",
    value: "13709",
  },
  {
    text: "Piräus / Athen (Griechenland)",
    value: "13716",
  },
  {
    text: "Point-à-Pitre (Guadeloupe)",
    value: "13729",
  },
  {
    text: "Ponta Delgada (São Miguel, Azoren)",
    value: "13735",
  },
  {
    text: "Port Canaveral / Orlando (Florida, USA)",
    value: "13742",
  },
  {
    text: "Port Louis (Mauritius)",
    value: "13752",
  },
  {
    text: "Porto (Portugal)",
    value: "13764",
  },
  {
    text: "Portsmouth (England)",
    value: "13782",
  },
  {
    text: "Potsdam (Deutschland)",
    value: "13786",
  },
  {
    text: "Prag (Tschechien)",
    value: "13787",
  },
  {
    text: "Praia (ilha de Sao Tiago, Kap Verde)",
    value: "13789",
  },
  {
    text: "Puerto Caldera (Costa Rica)",
    value: "13809",
  },
  {
    text: "Puerto Quetzal (Guatemala)",
    value: "13823",
  },
  {
    text: "Punta Arenas (Chile)",
    value: "13829",
  },
  {
    text: "Puntarenas (Costa Rica)",
    value: "13837",
  },
  {
    text: "Québec (Québec, Kanada)",
    value: "13845",
  },
  {
    text: "Regensburg (Deutschland)",
    value: "13863",
  },
  {
    text: "Reykjavik (Island)",
    value: "13871",
  },
  {
    text: "Rhodos (Griechenland)",
    value: "13872",
  },
  {
    text: "Rio de Janeiro (Brasilien)",
    value: "13880",
  },
  {
    text: "Rostock (Deutschland)",
    value: "13900",
  },
  {
    text: "Rotterdam (Neiderlande)",
    value: "13905",
  },
  {
    text: "Saarbrücken (Deutschland)",
    value: "13915",
  },
  {
    text: "Saarburg (Deutschland)",
    value: "13916",
  },
  {
    text: "Saint-Malo (Frankreich)",
    value: "13930",
  },
  {
    text: "Saint-Pierre (Saint-Pierre und Miquelon)",
    value: "13932",
  },
  {
    text: "Salvador da Bahia (Brasilien)",
    value: "13941",
  },
  {
    text: "San Diego (Kalifornien, USA)",
    value: "13948",
  },
  {
    text: "San Francisco (Kalifornien, USA)",
    value: "13950",
  },
  {
    text: "San Juan (Puerto Rico)",
    value: "13952",
  },
  {
    text: "Sansibar (Tansania)",
    value: "13965",
  },
  {
    text: "Sanra Cruz de Tenerife (Teneriffa, Kanaren)",
    value: "13973",
  },
  {
    text: "Santos (Sao Paulo, Brasilien)",
    value: "13985",
  },
  {
    text: "Savona (Italien)",
    value: "14001",
  },
  {
    text: "Seattle (Washington, USA)",
    value: "14014",
  },
  {
    text: "Seward / Anchorage (Alaska, USA)",
    value: "14021",
  },
  {
    text: "Shanghai (China)",
    value: "14025",
  },
  {
    text: "Singapur (Singapur)",
    value: "14038",
  },
  {
    text: "Sorrento (Italien)",
    value: "14058",
  },
  {
    text: "Southampton (England)",
    value: "14064",
  },
  {
    text: "St.John's (Antigua, Antigua und Barbuda)",
    value: "14082",
  },
  {
    text: "St.John's (Newfoundland, Kanada)",
    value: "14083",
  },
  {
    text: "St.Petersburg (Russland)",
    value: "14095",
  },
  {
    text: "Stockholm (Schweden)",
    value: "14109",
  },
  {
    text: "Stralsund (Deutschland)",
    value: "14112",
  },
  {
    text: "Straßburg (Frankreich)",
    value: "14113",
  },
  {
    text: "Stuttgart (Deutschland)",
    value: "14117",
  },
  {
    text: "Sydney (New South Wales, Australien)",
    value: "14134",
  },
  {
    text: "Syrakus (Sizilien, Italien)",
    value: "14138",
  },
  {
    text: "Tampa (Florida, USA)",
    value: "14156",
  },
  {
    text: "Tarragona (Spanien)",
    value: "14166",
  },
  {
    text: "Tema / Accra (Ghana)",
    value: "14169",
  },
  {
    text: "Thessaloniki (Griechenland)",
    value: "14180",
  },
  {
    text: "Tianjin Xingang / Peking (China)",
    value: "14186",
  },
  {
    text: "Tokio (Honshū , Japan)",
    value: "14199",
  },
  {
    text: "Toronto (Ontario, Kanada)",
    value: "14206",
  },
  {
    text: "Tower Bridge / London (England)",
    value: "14216",
  },
  {
    text: "Travemünde (Deutschland)",
    value: "14223",
  },
  {
    text: "Trier (Deutschland)",
    value: "14228",
  },
  {
    text: "Triest (Italien)",
    value: "14229",
  },
  {
    text: "Tromsø (Norwegen)",
    value: "14239",
  },
  {
    text: "Trondheim (Norwegen)",
    value: "14240",
  },
  {
    text: "Tsingtau (China)",
    value: "14243",
  },
  {
    text: "Ushuala (Feuerland, Argentinien)",
    value: "14268",
  },
  {
    text: "Velencia (Spanien)",
    value: "14279",
  },
  {
    text: "Valletta (Malta)",
    value: "14280",
  },
  {
    text: "Valparaíso / Santiago de Chile (Chile)",
    value: "14281",
  },
  {
    text: "Vancouver (British Columbia, Kanada)",
    value: "14282",
  },
  {
    text: "Venedig (Italien)",
    value: "14292",
  },
  {
    text: "Victoria (Mahe, Seychellen)",
    value: "14300",
  },
  {
    text: "Vigo (Spanien)",
    value: "14305",
  },
  {
    text: "Walfischbai (Namibia)",
    value: "14331",
  },
  {
    text: "Warnemünde (Deutschland)",
    value: "14333",
  },
  {
    text: "Whittier / Anchorage (Alaska, USA)",
    value: "14346",
  },
  {
    text: "Wien (Österreich)",
    value: "14347",
  },
  {
    text: "Wismar (Deutschland)",
    value: "14358",
  },
  {
    text: "Würzburg (Deutschland)",
    value: "14372",
  },
  {
    text: "Yangon / Rangun (Myanmar)",
    value: "14379",
  },
  {
    text: "Yokohama (Honshū , Japan) ",
    value: "14385",
  },
  {
    text: "Cayenne (Franz.-Guayana)",
    value: "14595",
  },
  {
    text: "Dún Laoghaire / Dublin (Irland)",
    value: "14606",
  },
  {
    text: "San Antonio (Chile)",
    value: "14748",
  },
  {
    text: "Anadyr (Russland)",
    value: "14822",
  },
  {
    text: "Santiago de Chile (Chile)",
    value: "14926",
  },
  {
    text: "Puerto Morelos (Mexico)",
    value: "14943",
  },
  {
    text: "Port Kembla (New South Wales, Australien)",
    value: "15094",
  },
  {
    text: "Køge (Sjælland, Dänemark)",
    value: "15164",
  },
  {
    text: "Goose Bay (Labrador, Kanada)",
    value: "15214",
  },
  {
    text: "Talcahuano (Chile)",
    value: "15322",
  },
  {
    text: "Kariba (Simbabwe)",
    value: "15438",
  },
  {
    text: "Chioggia / Venedig (Italien)",
    value: "15683",
  },
];
